/**
 * Format large numbers with K, M, B suffixes
 * @param num - The number to format
 * @returns Formatted string (e.g., 1.2K, 3.4M, 1.1B)
 */
export const formatNumber = (num: number): string => {
  if (num < 1000) {
    return num.toString();
  }
  
  if (num < 1000000) {
    const formatted = (num / 1000).toFixed(1);
    // Remove trailing .0
    return formatted.endsWith('.0') ? formatted.slice(0, -2) + 'K' : formatted + 'K';
  }
  
  if (num < 1000000000) {
    const formatted = (num / 1000000).toFixed(1);
    // Remove trailing .0
    return formatted.endsWith('.0') ? formatted.slice(0, -2) + 'M' : formatted + 'M';
  }
  
  const formatted = (num / 1000000000).toFixed(1);
  // Remove trailing .0
  return formatted.endsWith('.0') ? formatted.slice(0, -2) + 'B' : formatted + 'B';
};